/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input, inject } from "@angular/core";
import { SelectorComponent } from "./selector.component";

@Directive({ selector: "rask-selector[bindLabel]" })
export class SelectorLabelBindingDirective {
    private readonly selectorComponent = inject(SelectorComponent);

    @Input()
    protected set bindLabel(label: string) {
        const formatter = (item: any) => {
            if(!item) {
                return undefined;
            }
            return item[label];
        };
        this.selectorComponent.viewFormatter = formatter;
        this.selectorComponent.viewSelectedFormatter = formatter;
    }
}
